import { render, staticRenderFns } from "./ScanBox.vue?vue&type=template&id=f145188a&scoped=true"
import script from "./ScanBox.vue?vue&type=script&lang=js"
export * from "./ScanBox.vue?vue&type=script&lang=js"
import style0 from "./ScanBox.vue?vue&type=style&index=0&id=f145188a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f145188a",
  null
  
)

export default component.exports